import { render, staticRenderFns } from "./SdkAddReferensId.vue?vue&type=template&id=cf685a1e"
import script from "./SdkAddReferensId.vue?vue&type=script&lang=js"
export * from "./SdkAddReferensId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports